var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionH1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8438 44H43.6797V23.7656C43.6797 22.9974 43.6797 22.3398 43.6797 21.793C43.6927 21.2331 43.7057 20.7253 43.7188 20.2695C43.7448 19.8008 43.7773 19.3255 43.8164 18.8438C43.4128 19.2604 43.0352 19.6185 42.6836 19.918C42.332 20.2044 41.8958 20.5625 41.375 20.9922L38.1133 23.6094L36.4141 21.4023L44.1484 15.4453H46.8438V44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8555 44H25.5352V30.543H10.5352V44H7.21484V15.4453H10.5352V27.6133H25.5352V15.4453H28.8555V44Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionH1);
export default __webpack_public_path__ + "static/media/section-h1.0e5716bf0a5f4db423ff359af9cfa4fb.svg";
export { ForwardRef as ReactComponent };